import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _typeof from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import { defineComponent, ref, computed } from "vue";
import { ModalComponents } from "@/constants/modal";
import { useI18n } from "vue-i18n";
import { LogLevel, LogService } from "@/services/logging";
import dayjs from "dayjs";
import { generateReadableId } from "@/utils/helpers/app";
import UserModule from "@/store/modules/user";
import POSConfigModule from "@/store/modules/pos-config";
import { Currencies, allDetailedCurrencies } from "@/constants/currency";
import DeviceModule from "@/store/modules/device";
import BookingModule from "@/store/modules/booking";
import CashFloatModule from "@/store/modules/cash-float";
import randomstring from "randomstring";
import { getLastCashFloat } from "@/api/gql/device";
import { getLastCashFloatSeqIdFromDB, handleCashTransferSync, hasMultiCurrenciesEnabled } from "@/utils/vue-helpers/cash-float";
import { areObjectsEqual, convertToCents, roundToNearestMultipleOf5 } from "@/utils/helpers/common";
import { getProductCategoriesByTicketsGroup } from "@/utils/helpers/product-category";
import { PCTypes } from "@/types/db/product-category";
import { fetchAllPCsTimeslotsByDate, getTimeslotsByDate } from "@/utils/helpers/timeslots";
import { loadOffers } from "@/utils/helpers/offers";
import { syncDeviceLocation, syncGroupLocations } from "@/utils/helpers/device";
import { pushSyncCashfloat } from "@/api/cash-float/cash-float";
import NotificationService from "@/services/notification.service";
var CashfloatType;

(function (CashfloatType) {
  CashfloatType["Detailed"] = "Detailed";
  CashfloatType["General"] = "General";
})(CashfloatType || (CashfloatType = {}));

export default defineComponent({
  name: ModalComponents.NewCashFloatOpen,
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t; // Whether detailed or general


    var cashfloatType = ref("");
    var isMoneyAlreadyInDrawer = ref(false);
    var hasPreviousCashfloatMoney = ref(null);
    var showEditExistingAmountArea = ref(false);
    var cashDifferenceNote = ref(null); // used only if previous cashfloat wasn't cashed out and the money still exists in the drawer

    var previousCashfloatAmounts = computed(function () {
      var result = {};

      for (var i in currencies.value) {
        var _CashFloatModule$prev;

        var currency = currencies.value[i];
        result[currency.label] = result[currency.label] = (((_CashFloatModule$prev = CashFloatModule.previousCashfloat) === null || _CashFloatModule$prev === void 0 ? void 0 : _CashFloatModule$prev.closingAmounts[currency.label]) || 0) / 100;
      }

      return result;
    });
    var cashDetailsArea = ref(null);
    var submitingCashFloat = ref(false);
    var currencies = computed(function () {
      if (hasMultiCurrenciesEnabled.value) {
        return POSConfigModule.groupCurrencies;
      }

      var groupCurrency = POSConfigModule.groupCurrencies.find(function (currency) {
        return currency.isDefault === 1;
      });

      if (groupCurrency) {
        return [groupCurrency];
      }

      return [POSConfigModule.groupCurrencies[0]];
    });
    var groupCurrency = computed(function () {
      var currency = currencies.value.find(function (c) {
        return c.isDefault === 1;
      });
      return currency.label;
    }); // We only show in UI the currencies used by the organizer

    var detailedCurrencies = computed(function () {
      return allDetailedCurrencies.filter(function (c) {
        return currencies.value.some(function (currency) {
          return currency.label === c.label;
        });
      });
    });
    var detailedGroupCurrency = ref(detailedCurrencies.value.find(function (currency) {
      return currency.label === groupCurrency.value;
    }));
    var selectedDetailedCurrencies = computed(function () {
      return [detailedGroupCurrency.value].concat(_toConsumableArray(addedDetailedCurrencies.value));
    }); // contain ids of added currencies selected with dropdown

    var addedCurrencies = ref([]); // same for coins and bills

    var addedDetailedCurrencies = ref([]);
    var userFirstName = computed(function () {
      return UserModule.getUser.firstName;
    }); // this is an object whereas the keys are the values of label field in currencies variable

    var totalByCurrency = ref({});
    var notAddedCurrencies = computed(function () {
      return currencies.value.filter(function (currency) {
        return currency.label !== groupCurrency.value && !addedCurrencies.value.includes(currency.label);
      });
    });
    var notAddedCurrenciesCoinsAndBills = computed(function () {
      return detailedCurrencies.value.filter(function (currency) {
        return currency.label !== groupCurrency.value && !addedDetailedCurrencies.value.find(function (c) {
          return c.label === currency.label;
        });
      });
    });
    var isGeneralCashfloat = computed(function () {
      // we show general cashfloat if user clicked on general cashfloat btn or if previous cashfloat amount wasn't cashed out
      return cashfloatType.value === CashfloatType.General || hasPreviousCashfloatMoney.value;
    });
    var isDetailedCashfloat = computed(function () {
      return cashfloatType.value === CashfloatType.Detailed;
    });
    var canConfirmGeneralCashfloat = computed(function () {
      // we show confirm button if all currencies amounts are entered
      var hasAmount = true;
      var allAmountsAreZero = true;
      var keys = Object.keys(totalByCurrency.value);

      for (var i = 0; i < keys.length; i++) {
        if (keys[i] !== groupCurrency.value && !addedCurrencies.value.includes(keys[i])) {
          continue;
        }

        if (!totalByCurrency.value[keys[i]] && totalByCurrency.value[keys[i]] !== 0) {
          hasAmount = false;
        }

        if (totalByCurrency.value[keys[i]] > 0) {
          allAmountsAreZero = false;
        }
      } // return hasAmount && (isMoneyAlreadyInDrawer.value || locationId.value);


      if (hasAmount) {
        // user entered amount
        if (hasLocation.value) {
          // user machine is linked
          if (isMoneyAlreadyInDrawer.value || locationId.value || allAmountsAreZero) {
            // user action for money source is done
            return true;
          } else {
            // user action isn't done yet
            return false;
          }
        } else {
          // user machine isn't linked
          return true;
        }
      } else {
        // No amount
        return false;
      }
    });
    var canConfirmDetailedCashfloat = computed(function () {
      var canConfirm = true;

      for (var i = 0; i < selectedDetailedCurrencies.value.length; i++) {
        var currency = selectedDetailedCurrencies.value[i];

        if (!currency || !sumCashByCurrency(currency.label)) {
          canConfirm = false;
          break;
        }
      } // return (
      //   cashOpeningSum && (isMoneyAlreadyInDrawer.value || locationId.value)
      // );


      if (canConfirm) {
        // user entered amount
        if (hasLocation.value) {
          // user machine is linked
          if (isMoneyAlreadyInDrawer.value || locationId.value) {
            // user action for money source is done
            return true;
          } else {
            // user action isn't done yet
            return false;
          }
        } else {
          // user machine isn't linked
          return true;
        }
      } else {
        // No amount
        return false;
      }
    }); // TODO HAMZA MULTIPLE CURRENCIES SUPPORT: no need for this when we start supporting multiple currencies

    var cashfloatOpeningAmounts = computed(function () {
      return totalByCurrency.value;
    }); // TODO HAMZA LOCATIONS WORK: the below is only for testing. We need to have a better design for locations logic
    // await DeviceModule.fetchLocations();
    // locations shown to the user to choose from to becash out of this location

    var locationsList = computed(function () {
      return DeviceModule.locations.filter(function (l) {
        var _DeviceModule$hardwar;

        return l.id !== Number((_DeviceModule$hardwar = DeviceModule.hardwareLocation) === null || _DeviceModule$hardwar === void 0 ? void 0 : _DeviceModule$hardwar.locationId);
      });
    }); // this the selected location

    var locationId = ref(
    /*
    locationsList.value && locationsList.value.length
      ? locationsList.value[0].id
      : null*/
    null);
    var hasLocation = computed(function () {
      // If there is no hardware location (machine not linked to a location or user using a browser) we don't show device settings
      if (DeviceModule.hardwareLocation) {
        return true;
      } else {
        return false;
      }
    });

    function adjustAmount(val, currencyLabel) {
      if (currencyLabel === Currencies.CHF) {
        var intValue = Number(val);

        if (intValue) {
          var valueInCents = convertToCents(intValue);
          var finalValue = roundToNearestMultipleOf5(valueInCents) / 100;
          totalByCurrency.value[currencyLabel] = finalValue;
        }
      }
    } // reset total by currency in case user changes dropdown value after filling input


    function currencySelectChanged(newCurrencyLabel, oldCurrencyLabel) {
      if (newCurrencyLabel !== oldCurrencyLabel) {
        totalByCurrency.value[oldCurrencyLabel] = 0;
      }
    }

    function currencySelectChangedCoinsAndBills(newCurrencyLabel, oldCurrencyLabel, index) {
      if (newCurrencyLabel !== oldCurrencyLabel) {
        var detailedCurrencyToAdd = detailedCurrencies.value.find(function (currency) {
          return currency.label === newCurrencyLabel;
        });

        if (detailedCurrencyToAdd) {
          addedDetailedCurrencies.value[index] = detailedCurrencyToAdd;
        }
      }
    }

    function toggleCashfloatType(type) {
      cashfloatType.value = type;
      LogService.info("User chose ".concat(type, " cashfloat"));
    }

    function sumCashByCurrency(currencyId) {
      var currency = selectedDetailedCurrencies.value.find(function (c) {
        return c.label === currencyId;
      });

      if (currency) {
        var sum = 0;

        for (var i = 0; i < currency.bills.length; i++) {
          sum = sum + Number(currency.bills[i].name) * Number(currency.bills[i].userInput);
        }

        for (var _i = 0; _i < currency.coins.length; _i++) {
          sum = sum + Number(currency.coins[_i].name) * Number(currency.coins[_i].userInput);
        }

        for (var _i2 = 0; _i2 < currency.cents.length; _i2++) {
          sum = sum + Number(currency.cents[_i2].name) * Number(currency.cents[_i2].userInput) / 100;
        }

        return sum;
      }

      return 0;
    }

    function scrollToTop() {
      var _cashDetailsArea$valu;

      (_cashDetailsArea$valu = cashDetailsArea.value) === null || _cashDetailsArea$valu === void 0 ? void 0 : _cashDetailsArea$valu.scrollTo({
        // top: cashDetailsArea.value?.scrollHeight,
        top: 0,
        behavior: "smooth"
      });
    }

    function scrollTo(position) {
      var _cashDetailsArea$valu2;

      (_cashDetailsArea$valu2 = cashDetailsArea.value) === null || _cashDetailsArea$valu2 === void 0 ? void 0 : _cashDetailsArea$valu2.scrollTo({
        top: position,
        behavior: "smooth"
      });
    }

    function resetLocationId() {
      locationId.value = null;
    }

    function toggleShowEditExistingAmount() {
      showEditExistingAmountArea.value = !showEditExistingAmountArea.value;
    }

    function addCurrency() {
      var _iterator = _createForOfIteratorHelper(currencies.value),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;

          if (element.label !== groupCurrency.value && !addedCurrencies.value.includes(element.label)) {
            addedCurrencies.value.push(element.label);
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    function addCurrencyCoinsAndBills() {
      var _iterator2 = _createForOfIteratorHelper(detailedCurrencies.value),
          _step2;

      try {
        var _loop = function _loop() {
          var element = _step2.value;

          if (element.label !== groupCurrency.value && !addedDetailedCurrencies.value.find(function (c) {
            return c.label === element.label;
          })) {
            addedDetailedCurrencies.value.push(element);
            return {
              v: void 0
            };
          }
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ret = _loop();

          if (_typeof(_ret) === "object") return _ret.v;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    function removeAddedCurrency(currencyToRemove) {
      if (totalByCurrency.value[currencyToRemove]) {
        totalByCurrency.value[currencyToRemove] = 0;
      }

      addedCurrencies.value = addedCurrencies.value.filter(function (currency) {
        return currency !== currencyToRemove;
      });
    }

    function removeAddedCurrencyCoinsAndBills(currencyToRemove) {
      addedDetailedCurrencies.value = addedDetailedCurrencies.value.filter(function (detailedCurrency) {
        return detailedCurrency.label !== currencyToRemove;
      });
    }

    function submitDetailedCashfloat() {
      return _submitDetailedCashfloat.apply(this, arguments);
    }

    function _submitDetailedCashfloat() {
      _submitDetailedCashfloat = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var groupId, firstCurrency, cashOpeningSum, _DeviceModule$hardwar2, cashTransferIn, isSynced, message, lastSeqId, last, dateNow, uid, valuesForBackend, cashFloat, billsAndCoins, maxRetries, attempt;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                submitingCashFloat.value = true;
                LogService.info("Sale opening: User clicked to create a detailed cashfloat");
                groupId = POSConfigModule.groupId || UserModule.getUserGroupId;
                firstCurrency = detailedGroupCurrency.value;

                if (firstCurrency) {
                  _context.next = 7;
                  break;
                }

                LogService.info("Sale opening: Aborting submiting detailed cash float, no group currency set ", {
                  params: {
                    detailedCurrencies: detailedCurrencies.value,
                    groupCurrency: groupCurrency.value
                  }
                });
                return _context.abrupt("return");

              case 7:
                cashOpeningSum = sumCashByCurrency(firstCurrency.label); // We only do cash movement if user entered money and selected its source

                if (!(hasLocation.value && cashOpeningSum && locationId.value)) {
                  _context.next = 21;
                  break;
                }

                // Add a new CashTransfer of type (IN)
                cashTransferIn = {
                  _id: randomstring.generate(10) + dayjs().toISOString(),
                  createdAt: dayjs().toISOString(),
                  amount: cashOpeningSum,
                  currency: firstCurrency.label,
                  groupId: Number(groupId),
                  from: locationId.value || null,
                  to: Number((_DeviceModule$hardwar2 = DeviceModule.hardwareLocation) === null || _DeviceModule$hardwar2 === void 0 ? void 0 : _DeviceModule$hardwar2.locationId) || null,
                  note: ""
                  /*form.message || null*/
                  ,
                  channel: "Smeetz POS",
                  uuid: randomstring.generate(10)
                };

                if (CashFloatModule.initialTransferDone) {
                  _context.next = 17;
                  break;
                }

                _context.next = 13;
                return handleCashTransferSync(cashTransferIn);

              case 13:
                isSynced = _context.sent;

                if (isSynced) {
                  _context.next = 17;
                  break;
                }

                submitingCashFloat.value = false;
                return _context.abrupt("return");

              case 17:
                // In case cashfloat sync fails, we set the flag to true to avoid multiple cash transfer insertions
                CashFloatModule.setInitialTransferDone(true); // lets reset transferAmount

                CashFloatModule.setTransfersAmount(0);
                CashFloatModule.setSumOfCashIn(0);
                CashFloatModule.setSumOfCashOut(0);

              case 21:
                // Lets now build the cashfloat object
                message = ""; // let's get the seqId of the last cashfloat

                lastSeqId = 0;
                _context.prev = 23;
                _context.next = 26;
                return getLastCashFloat(DeviceModule.newLogicDeviceId);

              case 26:
                last = _context.sent;
                lastSeqId = Number(last.SeqId);
                _context.next = 36;
                break;

              case 30:
                _context.prev = 30;
                _context.t0 = _context["catch"](23);
                _context.next = 34;
                return getLastCashFloatSeqIdFromDB();

              case 34:
                lastSeqId = _context.sent;
                message = "Couldn't get last seq_id from backend";

              case 36:
                dateNow = dayjs().toISOString();
                uid = generateReadableId();
                valuesForBackend = {};
                detailedCurrencies.value.forEach(function (currency) {
                  valuesForBackend[currency.label] = convertToCents(sumCashByCurrency(currency.label));
                });
                cashFloat = {
                  seqId: lastSeqId + 1,
                  userId: UserModule.userId,
                  posId: null,
                  groupId: POSConfigModule.groupId || UserModule.getUserGroupId,
                  firstPosConfigId: POSConfigModule.selectedConfig ? POSConfigModule.selectedConfig.id : null,
                  startAmounts: valuesForBackend,
                  amounts: valuesForBackend,
                  userSwitch: [],
                  closeDate: "",
                  createdAt: dateNow,
                  updatedAt: dateNow,
                  uid: uid,
                  deviceId: DeviceModule.newLogicDeviceId,
                  version: 1,
                  message: message
                };

                if (cashOpeningSum) {
                  billsAndCoins = [];
                  selectedDetailedCurrencies.value.forEach(function (currency) {
                    billsAndCoins.push({
                      currency: currency.label,
                      bills: currency.bills.map(function (b) {
                        return {
                          name: b.name,
                          userInput: b.userInput
                        };
                      }),
                      coins: currency.coins.map(function (c) {
                        return {
                          name: c.name,
                          userInput: c.userInput
                        };
                      }),
                      cents: currency.cents.map(function (c) {
                        return {
                          name: c.name,
                          userInput: c.userInput
                        };
                      })
                    });
                  });
                  cashFloat.billsAndCoinsByCurrency = {
                    opening: billsAndCoins
                  };
                }

                maxRetries = 3;
                attempt = 1;

              case 44:
                if (!(attempt <= maxRetries)) {
                  _context.next = 67;
                  break;
                }

                _context.prev = 45;
                LogService.info("Sale opening: Submitting new cashfloat (attempt ".concat(attempt, "/").concat(maxRetries, "), uuid: ").concat(cashFloat.uid), {
                  cashfloat: cashFloat
                });
                _context.next = 49;
                return pushSyncCashfloat([cashFloat]);

              case 49:
                return _context.abrupt("break", 67);

              case 52:
                _context.prev = 52;
                _context.t1 = _context["catch"](45);

                if (!(attempt === maxRetries)) {
                  _context.next = 61;
                  break;
                }

                // Final attempt failed
                LogService.info("Sale opening: Error submitting new cashfloat after ".concat(maxRetries, " attempts, uuid: ").concat(cashFloat.uid), {
                  cashfloat: cashFloat,
                  error: _context.t1
                });
                NotificationService.showCustomMessage(t("error.open-sales"), "error");
                submitingCashFloat.value = false;
                return _context.abrupt("return");

              case 61:
                // Log the attempt failure but continue retrying
                LogService.info("Sale opening: Attempt ".concat(attempt, " failed, retrying... uuid: ").concat(cashFloat.uid), {
                  cashfloat: cashFloat,
                  error: _context.t1
                });
                _context.next = 64;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 1000);
                });

              case 64:
                attempt++;
                _context.next = 44;
                break;

              case 67:
                // reset the flag
                CashFloatModule.setInitialTransferDone(false);
                LogService.info("Setting a new cashfloat with uuid ".concat(cashFloat.uid), {
                  params: cashFloat
                });
                CashFloatModule.setCashFloat(cashFloat); // //clear the array of unsynched bookings

                BookingModule.clearAllPendingToSyncBookings(); // // Create first booking to have something on the UI

                BookingModule.createNewBooking();
                LogService.info("Created cashfloat with uuid ".concat(cashFloat.uid), {
                  params: cashFloat
                }); // Now lets log current memory consumption

                logMemoryConsumption(); // ModalModule.setStatus(ModalStatus.Hidden);

                CashFloatModule.setIsOpeningCashfloat(false); // fetch timeslots in case they did not exist in indexedDB

                loadTodaysTimeSlotsIfNone(); // pull available offers

                _context.prev = 76;
                _context.next = 79;
                return loadOffers();

              case 79:
                LogService.info("Offers object instantiated");
                _context.next = 85;
                break;

              case 82:
                _context.prev = 82;
                _context.t2 = _context["catch"](76);
                LogService.info("Failed to instantiate offers object", {
                  error: _context.t2
                });

              case 85:
                submitingCashFloat.value = false;

              case 86:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[23, 30], [45, 52], [76, 82]]);
      }));
      return _submitDetailedCashfloat.apply(this, arguments);
    }

    function submitGeneralCashfloat() {
      return _submitGeneralCashfloat.apply(this, arguments);
    }

    function _submitGeneralCashfloat() {
      _submitGeneralCashfloat = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var groupId, firstCurrency, openingAmountsValid, _DeviceModule$hardwar3, cashTransferIn, isSynced, message, lastSeqId, last, dateNow, uid, cashfloatOpeningAmountsForBackend, key, cashFloat, maxRetries, attempt;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                submitingCashFloat.value = true;
                LogService.info("Sale opening: User clicked to create a general cashfloat");
                groupId = POSConfigModule.groupId || UserModule.getUserGroupId; // We only do cash movement if user entered money and selected its source

                firstCurrency = detailedGroupCurrency.value;

                if (firstCurrency) {
                  _context2.next = 7;
                  break;
                }

                LogService.info("Sale opening: Aborting submiting general cash float, no group currency set ", {
                  params: {
                    detailedCurrencies: detailedCurrencies.value,
                    groupCurrency: groupCurrency.value
                  }
                });
                return _context2.abrupt("return");

              case 7:
                openingAmountsValid = true;

                if (isNaN(Number(cashfloatOpeningAmounts.value[firstCurrency.label]))) {
                  openingAmountsValid = false;
                }

                if (!(hasLocation.value && openingAmountsValid && locationId.value)) {
                  _context2.next = 23;
                  break;
                }

                // Add a new CashTransfer of type (IN)
                cashTransferIn = {
                  _id: dayjs().toISOString(),
                  createdAt: dayjs().toISOString(),
                  amount: Number(cashfloatOpeningAmounts.value[firstCurrency.label]),
                  currency: firstCurrency.label,
                  groupId: Number(groupId),
                  from: locationId.value || null,
                  to: Number((_DeviceModule$hardwar3 = DeviceModule.hardwareLocation) === null || _DeviceModule$hardwar3 === void 0 ? void 0 : _DeviceModule$hardwar3.locationId) || null,
                  note: ""
                  /*form.message || null*/
                  ,
                  channel: "Smeetz POS",
                  uuid: randomstring.generate(10)
                };
                LogService.info("Inserting cashTranser to indexedDB (attached)", {
                  params: cashTransferIn
                });

                if (CashFloatModule.initialTransferDone) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 15;
                return handleCashTransferSync(cashTransferIn);

              case 15:
                isSynced = _context2.sent;

                if (isSynced) {
                  _context2.next = 19;
                  break;
                }

                submitingCashFloat.value = false;
                return _context2.abrupt("return");

              case 19:
                // In case cashfloat sync fails, we set the flag to true to avoid multiple cash transfer insertions
                CashFloatModule.setInitialTransferDone(true); // lets reset transferAmount

                CashFloatModule.setTransfersAmount(0);
                CashFloatModule.setSumOfCashIn(0);
                CashFloatModule.setSumOfCashOut(0);

              case 23:
                message = ""; // let's get the seqId of the last cashfloat

                lastSeqId = 0;
                _context2.prev = 25;
                _context2.next = 28;
                return getLastCashFloat(DeviceModule.newLogicDeviceId);

              case 28:
                last = _context2.sent;
                lastSeqId = Number(last.SeqId);
                _context2.next = 38;
                break;

              case 32:
                _context2.prev = 32;
                _context2.t0 = _context2["catch"](25);
                _context2.next = 36;
                return getLastCashFloatSeqIdFromDB();

              case 36:
                lastSeqId = _context2.sent;
                message = "Couldn't get last seq_id from backend";

              case 38:
                dateNow = dayjs().toISOString();
                uid = generateReadableId();
                cashfloatOpeningAmountsForBackend = {};

                for (key in cashfloatOpeningAmounts.value) {
                  cashfloatOpeningAmountsForBackend[key] = convertToCents(Number(cashfloatOpeningAmounts.value[key]));
                }

                cashFloat = {
                  seqId: lastSeqId + 1,
                  userId: UserModule.userId,
                  posId: null,
                  groupId: POSConfigModule.groupId || UserModule.getUserGroupId,
                  firstPosConfigId: POSConfigModule.selectedConfig ? POSConfigModule.selectedConfig.id : null,
                  startAmounts: cashfloatOpeningAmountsForBackend,
                  amounts: cashfloatOpeningAmountsForBackend,
                  userSwitch: [],
                  closeDate: "",
                  createdAt: dateNow,
                  updatedAt: dateNow,
                  uid: uid,
                  deviceId: DeviceModule.newLogicDeviceId,
                  version: 1,
                  billsAndCoinsByCurrency: {},
                  message: message
                };
                maxRetries = 3;
                attempt = 1;

              case 45:
                if (!(attempt <= maxRetries)) {
                  _context2.next = 68;
                  break;
                }

                _context2.prev = 46;
                LogService.info("Sale opening: Submitting new cashfloat (attempt ".concat(attempt, "/").concat(maxRetries, "), uuid: ").concat(cashFloat.uid), {
                  cashfloat: cashFloat
                });
                _context2.next = 50;
                return pushSyncCashfloat([cashFloat]);

              case 50:
                return _context2.abrupt("break", 68);

              case 53:
                _context2.prev = 53;
                _context2.t1 = _context2["catch"](46);

                if (!(attempt === maxRetries)) {
                  _context2.next = 62;
                  break;
                }

                // Final attempt failed
                LogService.info("Sale opening: Error submitting new cashfloat after ".concat(maxRetries, " attempts, uuid: ").concat(cashFloat.uid), {
                  cashfloat: cashFloat,
                  error: _context2.t1
                });
                NotificationService.showCustomMessage(t("error.open-sales"), "error");
                submitingCashFloat.value = false;
                return _context2.abrupt("return");

              case 62:
                // Log the attempt failure but continue retrying
                LogService.info("Sale opening: Attempt ".concat(attempt, " failed, retrying... uuid: ").concat(cashFloat.uid), {
                  cashfloat: cashFloat,
                  error: _context2.t1
                });
                _context2.next = 65;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 1000);
                });

              case 65:
                attempt++;
                _context2.next = 45;
                break;

              case 68:
                // reset the flag
                CashFloatModule.setInitialTransferDone(false);
                LogService.info("Setting a new cashfloat with uuid ".concat(cashFloat.uid), {
                  params: cashFloat
                });
                CashFloatModule.setCashFloat(cashFloat); // //clear the array of unsynched bookings

                BookingModule.clearAllPendingToSyncBookings(); // // Create first booking to have something on the UI

                BookingModule.createNewBooking();
                LogService.info("Created cashfloat with uuid ".concat(cashFloat.uid), {
                  params: cashFloat
                }); // Now lets log current memory consumption

                logMemoryConsumption(); // ModalModule.setStatus(ModalStatus.Hidden);

                CashFloatModule.setIsOpeningCashfloat(false); // fetch timeslots in case they did not exist in indexedDB

                loadTodaysTimeSlotsIfNone(); // pull available offers

                _context2.prev = 77;
                _context2.next = 80;
                return loadOffers();

              case 80:
                LogService.info("Offers object instantiated");
                _context2.next = 86;
                break;

              case 83:
                _context2.prev = 83;
                _context2.t2 = _context2["catch"](77);
                LogService.info("Failed to instantiate offers object", {
                  error: _context2.t2
                });

              case 86:
                submitingCashFloat.value = false;

              case 87:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[25, 32], [46, 53], [77, 83]]);
      }));
      return _submitGeneralCashfloat.apply(this, arguments);
    }

    function submitGeneralCashfloatWhenMoneyAlreadyExistingInDrawer() {
      return _submitGeneralCashfloatWhenMoneyAlreadyExistingInDrawer.apply(this, arguments);
    }

    function _submitGeneralCashfloatWhenMoneyAlreadyExistingInDrawer() {
      _submitGeneralCashfloatWhenMoneyAlreadyExistingInDrawer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var groupId, firstCurrency, from, to, _DeviceModule$hardwar4, _DeviceModule$hardwar5, _DeviceModule$hardwar6, _DeviceModule$hardwar7, cashTransfer, isSynced, dateNow, uid, valuesForBackend, i, currency, message, lastSeqId, last, cashFloat, maxRetries, attempt;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // This is the case where the user had money in the drawer already
                // If user confirmed the amount that already exist in the drawer then we'll do a cashfloat synch only
                // If user entered a manual amount, then we`ll first do cash transfer with isGainLoss to justify the difference
                // then we synch the cashfloat
                submitingCashFloat.value = true;
                LogService.info("Sale opening: Creating a cashfloat with an existing money from previous cashfloat");

                if (!(!cashfloatOpeningAmounts.value || areObjectsEqual(cashfloatOpeningAmounts.value, previousCashfloatAmounts.value))) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 23;
                break;

              case 5:
                // so user did change the amount of the previous cashfloat
                // we will do a cash transfer to justify where the extra money came from or where the missing money went
                ////
                LogService.info("When Opening cashfloat, user entered manual amount different than previous cashfloat amount", {
                  params: {
                    previousCashfloatAmounts: previousCashfloatAmounts.value,
                    manualOpeningAmounts: cashfloatOpeningAmounts.value
                  }
                });
                groupId = POSConfigModule.groupId || UserModule.getUserGroupId; // For now backend only support one currency

                firstCurrency = detailedGroupCurrency.value;

                if (firstCurrency) {
                  _context3.next = 11;
                  break;
                }

                LogService.info("Sale opening: Aborting submiting general cash float, no group currency set ", {
                  params: {
                    detailedCurrencies: detailedCurrencies.value,
                    groupCurrency: groupCurrency.value
                  }
                });
                return _context3.abrupt("return");

              case 11:
                from = null;
                to = null;

                if (cashfloatOpeningAmounts.value[firstCurrency.label] > (previousCashfloatAmounts.value[firstCurrency.label] || 0)) {
                  // gain
                  to = DeviceModule.hardwareLocation && (_DeviceModule$hardwar4 = DeviceModule.hardwareLocation) !== null && _DeviceModule$hardwar4 !== void 0 && _DeviceModule$hardwar4.locationId ? Number((_DeviceModule$hardwar5 = DeviceModule.hardwareLocation) === null || _DeviceModule$hardwar5 === void 0 ? void 0 : _DeviceModule$hardwar5.locationId) : null;
                  from = null;
                } else {
                  // cashOut from the device because it is a loss
                  from = DeviceModule.hardwareLocation && (_DeviceModule$hardwar6 = DeviceModule.hardwareLocation) !== null && _DeviceModule$hardwar6 !== void 0 && _DeviceModule$hardwar6.locationId ? Number((_DeviceModule$hardwar7 = DeviceModule.hardwareLocation) === null || _DeviceModule$hardwar7 === void 0 ? void 0 : _DeviceModule$hardwar7.locationId) : null;
                  to = null;
                }

                cashTransfer = {
                  _id: dayjs().toISOString(),
                  createdAt: dayjs().toISOString(),
                  amount: Math.abs(Number(previousCashfloatAmounts.value[firstCurrency.label]) - Number(cashfloatOpeningAmounts.value[firstCurrency.label])),
                  currency: firstCurrency.label,
                  groupId: Number(groupId),
                  from: from,
                  to: to,
                  note: cashDifferenceNote.value,
                  channel: "Smeetz POS",
                  uuid: randomstring.generate(10),
                  isGainLoss: true
                };

                if (CashFloatModule.initialTransferDone) {
                  _context3.next = 22;
                  break;
                }

                _context3.next = 18;
                return handleCashTransferSync(cashTransfer);

              case 18:
                isSynced = _context3.sent;

                if (isSynced) {
                  _context3.next = 22;
                  break;
                }

                submitingCashFloat.value = false;
                return _context3.abrupt("return");

              case 22:
                // In case cashfloat sync fails, we set the flag to true to avoid multiple cash transfer insertions
                CashFloatModule.setInitialTransferDone(true);

              case 23:
                // lets reset transferAmount
                LogService.info("Sale opening: Setting cashIn and cashOut from previous session to 0");
                CashFloatModule.setTransfersAmount(0);
                CashFloatModule.setSumOfCashIn(0);
                CashFloatModule.setSumOfCashOut(0);
                dateNow = dayjs().toISOString();
                uid = generateReadableId();
                valuesForBackend = {};

                for (i in currencies.value) {
                  currency = currencies.value[i];

                  if (cashfloatOpeningAmounts.value[currency.label]) {
                    // so user entered amount
                    // it could be the case where there were no money in the drawer
                    // and it could be the case where there were money in the drawer but user edited it
                    valuesForBackend[currency.label] = convertToCents(cashfloatOpeningAmounts.value[currency.label]);
                  } else if (previousCashfloatAmounts.value[currency.label]) {
                    // so user didn't enter any amount but we have the drawer already having money in it
                    // we will consider it as initial amount of the new cashfloat
                    valuesForBackend[currency.label] = convertToCents(previousCashfloatAmounts.value[currency.label] || 0);
                  } else {
                    valuesForBackend[currency.label] = 0;
                  }
                }

                message = ""; // let's get the seqId of the last cashfloat

                lastSeqId = 0;
                _context3.prev = 33;
                _context3.next = 36;
                return getLastCashFloat(DeviceModule.newLogicDeviceId);

              case 36:
                last = _context3.sent;
                lastSeqId = Number(last.SeqId);
                _context3.next = 46;
                break;

              case 40:
                _context3.prev = 40;
                _context3.t0 = _context3["catch"](33);
                _context3.next = 44;
                return getLastCashFloatSeqIdFromDB();

              case 44:
                lastSeqId = _context3.sent;
                message = "Couldn't get last seq_id from backend";

              case 46:
                cashFloat = {
                  seqId: lastSeqId + 1,
                  userId: UserModule.userId,
                  posId: null,
                  groupId: POSConfigModule.groupId || UserModule.getUserGroupId,
                  firstPosConfigId: POSConfigModule.selectedConfig ? POSConfigModule.selectedConfig.id : null,
                  startAmounts: valuesForBackend,
                  amounts: valuesForBackend,
                  userSwitch: [],
                  closeDate: "",
                  createdAt: dateNow,
                  updatedAt: dateNow,
                  uid: uid,
                  deviceId: DeviceModule.newLogicDeviceId,
                  version: 1,
                  billsAndCoinsByCurrency: {},
                  message: message
                };
                maxRetries = 3;
                attempt = 1;

              case 49:
                if (!(attempt <= maxRetries)) {
                  _context3.next = 72;
                  break;
                }

                _context3.prev = 50;
                LogService.info("Sale opening: Submitting new cashfloat (attempt ".concat(attempt, "/").concat(maxRetries, "), uuid: ").concat(cashFloat.uid), {
                  cashfloat: cashFloat
                });
                _context3.next = 54;
                return pushSyncCashfloat([cashFloat]);

              case 54:
                return _context3.abrupt("break", 72);

              case 57:
                _context3.prev = 57;
                _context3.t1 = _context3["catch"](50);

                if (!(attempt === maxRetries)) {
                  _context3.next = 66;
                  break;
                }

                // Final attempt failed
                LogService.info("Sale opening: Error submitting new cashfloat after ".concat(maxRetries, " attempts, uuid: ").concat(cashFloat.uid), {
                  cashfloat: cashFloat,
                  error: _context3.t1
                });
                NotificationService.showCustomMessage(t("error.open-sales"), "error");
                submitingCashFloat.value = false;
                return _context3.abrupt("return");

              case 66:
                // Log the attempt failure but continue retrying
                LogService.info("Sale opening: Attempt ".concat(attempt, " failed, retrying... uuid: ").concat(cashFloat.uid), {
                  cashfloat: cashFloat,
                  error: _context3.t1
                });
                _context3.next = 69;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 1000);
                });

              case 69:
                attempt++;
                _context3.next = 49;
                break;

              case 72:
                // reset the flag
                CashFloatModule.setInitialTransferDone(false);
                LogService.info("Setting a new cashfloat with uuid ".concat(cashFloat.uid), {
                  params: cashFloat
                });
                CashFloatModule.setCashFloat(cashFloat); // //clear the array of unsynched bookings

                BookingModule.clearAllPendingToSyncBookings(); // // Create first booking to have something on the UI

                BookingModule.createNewBooking();
                LogService.info("Created cashfloat with uuid ".concat(cashFloat.uid), {
                  params: cashFloat
                }); // Now lets log current memory consumption

                logMemoryConsumption(); // ModalModule.setStatus(ModalStatus.Hidden);

                CashFloatModule.setIsOpeningCashfloat(false); // fetch timeslots in case they did not exist in indexedDB

                loadTodaysTimeSlotsIfNone(); // pull available offers

                _context3.prev = 81;
                _context3.next = 84;
                return loadOffers();

              case 84:
                LogService.info("Offers object instantiated");
                _context3.next = 90;
                break;

              case 87:
                _context3.prev = 87;
                _context3.t2 = _context3["catch"](81);
                LogService.info("Failed to instantiate offers object", {
                  error: _context3.t2
                });

              case 90:
                submitingCashFloat.value = false;

              case 91:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[33, 40], [50, 57], [81, 87]]);
      }));
      return _submitGeneralCashfloatWhenMoneyAlreadyExistingInDrawer.apply(this, arguments);
    }

    function logMemoryConsumption() {
      try {
        if (window.performance && window.performance.memory) {
          var memory = window.performance.memory;
          var mem = {
            date: dayjs().utc().toISOString(),
            totalJSHeapSize: memory.totalJSHeapSize / (1024 * 1024),
            usedJSHeapSize: memory.usedJSHeapSize / (1024 * 1024),
            jsHeapSizeLimit: memory.jsHeapSizeLimit / (1024 * 1024),
            domMemory: (memory.totalJSHeapSize - memory.usedJSHeapSize) / (1024 * 1024)
          };
          LogService.info("Memory consumption after starting sales", {
            params: {
              memoryConsumption: mem
            }
          });
        }
      } catch (err) {
        // Couldn't log memory consumption
        LogService.info("Error when trying to log memory consumption", {
          params: {
            error: err
          }
        }, LogLevel.Error);
      }
    }

    function handleInputFocus(event) {
      if (event.target.value === "0") {
        event.target.value = "";
      }
    }

    function handleInputBlur(event) {
      if (event.target.value === "") {
        event.target.value = "0";
      }
    } // checks if todays timeslots are present in indexedDB or not, if not it fetches them from backend
    // this is to handle the case where user do not logout overnight and end up not reloading their configs


    function loadTodaysTimeSlotsIfNone() {
      return _loadTodaysTimeSlotsIfNone.apply(this, arguments);
    }

    function _loadTodaysTimeSlotsIfNone() {
      _loadTodaysTimeSlotsIfNone = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _POSConfigModule$getS;

        var ticketGroups, today, i, ticketGroup, dayTimeSlots, productCategories, productCategoriesIds;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                ticketGroups = (_POSConfigModule$getS = POSConfigModule.getSelectedConfig) === null || _POSConfigModule$getS === void 0 ? void 0 : _POSConfigModule$getS.ticketGroups;

                if (ticketGroups !== null && ticketGroups !== void 0 && ticketGroups.length) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                today = new Date(dayjs().toDate().toDateString() + " " + new Date().toTimeString());
                i = 0;

              case 5:
                if (!(i < ticketGroups.length)) {
                  _context4.next = 20;
                  break;
                }

                ticketGroup = ticketGroups[i];
                _context4.next = 9;
                return getTimeslotsByDate(today, ticketGroup);

              case 9:
                dayTimeSlots = _context4.sent;

                if (dayTimeSlots !== null && dayTimeSlots !== void 0 && dayTimeSlots.length) {
                  _context4.next = 17;
                  break;
                }

                _context4.next = 13;
                return getProductCategoriesByTicketsGroup(ticketGroup);

              case 13:
                productCategories = _context4.sent;
                productCategoriesIds = (productCategories === null || productCategories === void 0 ? void 0 : productCategories.map(function (pc) {
                  // if this is a seating plan then we consider the parent category id because the child category isn't linked to the timeslots
                  if (pc.type === PCTypes[PCTypes.SeatedSub] && pc.seatingParentPSCId) return pc.seatingParentPSCId;
                  return pc.id;
                })) || []; // Fetch timeslots of today

                _context4.next = 17;
                return fetchAllPCsTimeslotsByDate(productCategoriesIds, today.toISOString());

              case 17:
                i++;
                _context4.next = 5;
                break;

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _loadTodaysTimeSlotsIfNone.apply(this, arguments);
    }

    return {
      t: t,
      cashfloatType: cashfloatType,
      isGeneralCashfloat: isGeneralCashfloat,
      isDetailedCashfloat: isDetailedCashfloat,
      toggleCashfloatType: toggleCashfloatType,
      CashfloatType: CashfloatType,
      currencies: currencies,
      detailedCurrencies: detailedCurrencies,
      totalByCurrency: totalByCurrency,
      canConfirmGeneralCashfloat: canConfirmGeneralCashfloat,
      canConfirmDetailedCashfloat: canConfirmDetailedCashfloat,
      cashfloatOpeningAmounts: cashfloatOpeningAmounts,
      locationsList: locationsList,
      locationId: locationId,
      sumCashByCurrency: sumCashByCurrency,
      scrollToTop: scrollToTop,
      cashDetailsArea: cashDetailsArea,
      scrollTo: scrollTo,
      userFirstName: userFirstName,
      hasLocation: hasLocation,
      isMoneyAlreadyInDrawer: isMoneyAlreadyInDrawer,
      resetLocationId: resetLocationId,
      hasPreviousCashfloatMoney: hasPreviousCashfloatMoney,
      previousCashfloatAmounts: previousCashfloatAmounts,
      showEditExistingAmountArea: showEditExistingAmountArea,
      toggleShowEditExistingAmount: toggleShowEditExistingAmount,
      cashDifferenceNote: cashDifferenceNote,
      addedCurrencies: addedCurrencies,
      groupCurrency: groupCurrency,
      currencySelectChanged: currencySelectChanged,
      addCurrency: addCurrency,
      notAddedCurrencies: notAddedCurrencies,
      removeAddedCurrency: removeAddedCurrency,
      addedDetailedCurrencies: addedDetailedCurrencies,
      notAddedCurrenciesCoinsAndBills: notAddedCurrenciesCoinsAndBills,
      addCurrencyCoinsAndBills: addCurrencyCoinsAndBills,
      removeAddedCurrencyCoinsAndBills: removeAddedCurrencyCoinsAndBills,
      detailedGroupCurrency: detailedGroupCurrency,
      currencySelectChangedCoinsAndBills: currencySelectChangedCoinsAndBills,
      selectedDetailedCurrencies: selectedDetailedCurrencies,
      submitDetailedCashfloat: submitDetailedCashfloat,
      submitGeneralCashfloat: submitGeneralCashfloat,
      submitGeneralCashfloatWhenMoneyAlreadyExistingInDrawer: submitGeneralCashfloatWhenMoneyAlreadyExistingInDrawer,
      hasMultiCurrenciesEnabled: hasMultiCurrenciesEnabled,
      adjustAmount: adjustAmount,
      handleInputFocus: handleInputFocus,
      handleInputBlur: handleInputBlur,
      submitingCashFloat: submitingCashFloat
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var previousCashfloatInfo, curr, currency;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              LogService.info("CashfloatOpen component created: Syncing device location"); // Check and sync device location if needed

              _context5.next = 3;
              return syncGroupLocations();

            case 3:
              _context5.next = 5;
              return syncDeviceLocation();

            case 5:
              // initialize all currency amounts to 0
              _this.currencies.forEach(function (currency) {
                if (typeof _this.totalByCurrency[currency.label] === "undefined") {
                  _this.totalByCurrency[currency.label] = 0;
                }
              });

              previousCashfloatInfo = CashFloatModule.getPreviousCashfloat; // if user is using a linked device, then we will check if the drawer has money from previous cashfloat

              if (_this.hasLocation) {
                if (previousCashfloatInfo && !previousCashfloatInfo.isCashedOut) {
                  // user didn't cash out previous cashfloat
                  _this.hasPreviousCashfloatMoney = true; // set currency amounts to match previous uncashed cashfloat

                  for (curr in previousCashfloatInfo.closingAmounts) {
                    currency = curr;

                    if (_typeof(previousCashfloatInfo.closingAmounts[currency]) !== undefined) {
                      // divide by 100, since closingAmounts is in cents
                      _this.totalByCurrency[currency] = (previousCashfloatInfo.closingAmounts[currency] || 0) / 100;
                    }
                  }
                }
              }

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  mounted: function mounted() {
    // lets reset transferAmount
    LogService.info("CashfloatOpen component mounted: Setting cashIn and cashOut from previous session to 0");
    CashFloatModule.setTransfersAmount(0);
    CashFloatModule.setSumOfCashIn(0);
    CashFloatModule.setSumOfCashOut(0); // Logging payment settings

    LogService.info("Payment settings of the user: ", {
      params: POSConfigModule.getPaymentSettings
    });
  },
  methods: {
    cancel: function cancel() {
      // ModalModule.setStatus(ModalStatus.Hidden);
      CashFloatModule.setIsOpeningCashfloat(false);
    }
  }
});